import React from 'react';

export const UnpairedIcon = (props) => {
  const { className = '', style = {}, disabled = false, onClick, label } = props;

  // Set the width based on the label
  const baseWidth = 114;
  const padding = 50;
  const charWidth = 8;
  const width = Math.max(baseWidth, label.length * charWidth + padding);

  return (
    <svg
      className={className}
      style={style}
      width={width}
      height="36"
      viewBox={`0 0 ${width} 36`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width={width} height="36" rx="18" fill="#F46363" />
      <path
        d="M22.0013 9.66602C17.408 9.66602 13.668 13.4061 13.668 17.9993C13.668 22.5926 17.408 26.3327 22.0013 26.3327C26.5946 26.3327 30.3346 22.5926 30.3346 17.9993C30.3346 13.4061 26.5946 9.66602 22.0013 9.66602ZM22.0013 24.6164C18.3505 24.6164 15.3842 21.6501 15.3842 17.9993C15.3842 14.3486 18.3406 11.3823 22.0013 11.3823C25.662 11.3823 28.6184 14.3486 28.6184 17.9993C28.6184 21.6501 25.662 24.6164 22.0013 24.6164Z"
        fill="black"
      />
      <path
        d="M23.2884 14.7432L21.9987 16.033L20.709 14.7432C20.1633 14.1976 19.2869 14.1976 18.7413 14.7432C18.1956 15.2889 18.1956 16.1653 18.7413 16.7109L20.031 18.0007L18.7413 19.2904C18.1956 19.8361 18.1956 20.7124 18.7413 21.2581C19.2869 21.8037 20.1633 21.8037 20.709 21.2581L21.9987 19.9683L23.2884 21.2581C23.8341 21.8037 24.7105 21.8037 25.2561 21.2581C25.8018 20.7124 25.8018 19.8361 25.2561 19.2904L23.9664 18.0007L25.2561 16.7109C25.8018 16.1653 25.8018 15.2889 25.2561 14.7432C24.7105 14.1976 23.8341 14.1976 23.2884 14.7432Z"
        fill="black"
      />
      <text
        x={width - 10}
        y="50%"
        dominantBaseline="middle"
        textAnchor="end"
        fontFamily="Euclid Circular A"
        fontSize="14px"
        fill="black"
        fontWeight="bold"
        textLength={width - 50}
        lengthAdjust="spacing"
      >
        {label}
      </text>
    </svg>
  );
};
